module.exports = __webpack_public_path__ + "media/assets/images/goodbye-e6ecfe6768454ef48d15cf0c95c7eb7c.jpg";